import { render, staticRenderFns } from "./HeroTextMediaColumns.vue?vue&type=template&id=56b1e752"
import script from "./HeroTextMediaColumns.vue?vue&type=script&lang=ts"
export * from "./HeroTextMediaColumns.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports